import React, { useState } from "react";
import styles from "./FormDetails.module.css";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { FaUserPlus } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import { saveLeave } from "../../redux/slices/leaveSlice";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";

const dummyStudents = [
  { id: "s1", name: "John" },
  { id: "s2", name: "Steeve" },
  { id: "s3", name: "John" },
  { id: "s4", name: "Steeve" },
  { id: "s5", name: "John" },
  { id: "s6", name: "Steeve" },
  { id: "s7", name: "John" },
  { id: "s8", name: "Steeve" },
  { id: "s9", name: "John" },
  { id: "s10", name: "Steeve" },
];

const FormDetails = ({ goNext }) => {
  const dispatch = useDispatch();
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [leaveType, setLeaveType] = useState("");
  const [reason, setReason] = useState("");
  const [programName, setProgramName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [days, setDays] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [label, setLabel] = useState("");
  const [room, setRoom] = useState("");
  const [maxStudents, setMaxStudents] = useState("");
  const [maxStaff, setMaxStaff] = useState("");
  const [aboveCapStudent, setAboveCapStudent] = useState(false);
  const [aboveCapStaff, setAboveCapStaff] = useState(false);
  const [minAgeYrs, setMinAgeYrs] = useState("0");
  const [minAgeMonths, setMinAgeMonths] = useState("0");
  const [maxAgeYrs, setMaxAgeYrs] = useState("0");
  const [maxAgeMonths, setMaxAgeMonths] = useState("0");
  const allDays = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];

  const handleToggleDay = (day) => {
    setDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const validateRequiredFields = () => {
    if (
      !programName ||
      !fromDate ||
      !toDate ||
      days.length === 0 ||
      !startTime ||
      !endTime ||
      !label ||
      !room
    ) {
      alert("Please fill in all required fields (*)");
      return false;
    }
    return true;
  };

  const handleProgramSave = () => {
    if (!validateRequiredFields()) return;

    console.log({
      programName,
      fromDate,
      toDate,
      days,
      startTime,
      endTime,
      label,
      room,
      aboveCapStudent,
      aboveCapStaff,
      maxStudents,
      maxStaff,
      minAgeYrs,
      minAgeMonths,
      maxAgeYrs,
      maxAgeMonths,
    });
  };
  const handleNextClick = () => {
    // if (!validateRequiredFields()) return;

    const mainContainer = document.querySelector("Main");
    mainContainer.scrollTo(0, 0); 
    goNext?.(); // only call if passed
  };
  

  const handleProgramCancel = () => {
    setProgramName("");
    setFromDate("");
    setToDate("");
    setDays([]);
    setStartTime("");
    setEndTime("");
    setLabel("");
    setRoom("");
    setAboveCapStudent(false);
    setAboveCapStaff(false);
    setMaxStudents("");
    setMaxStaff("");
    setMinAgeYrs("0");
    setMinAgeMonths("0");
    setMaxAgeYrs("0");
    setMaxAgeMonths("0");
  };

  const handleCheckboxChange = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const filteredStudents = dummyStudents.filter((student) =>
    student.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleSave = () => {
    const leaveEntry = {
      fromDate,
      toDate,
      leaveType,
      reason,
      attachment: uploadedFile,
    };

    dispatch(saveLeave(leaveEntry));
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setSelectedStudents([]);
    setSearch("");
    setLeaveType("");
    setReason("");
    setFromDate("");
    setToDate("");
  };

  return (
    <div className={styles.container}>
      {/* Program Details */}
      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Form Details" />
        </div>
        <div className={styles.studentdata}>
          <div className={styles.row}>
            <HeadingAndData
              label="Form Name"
              name="formName"
              placeholder="Enter form name"
              value={programName}
              onChange={(e) => setProgramName(e.target.value)}
              required
            />
            <HeadingAndDropDown
              label="Form Status"
              name="formStatus"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              required
              options={[
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
              ]}
              placeholder="Select Status"
            />
            <HeadingAndDropDown
              label="Notify Staff"
              name="notifyStaff"
              value={room}
              onChange={(e) => setRoom(e.target.value)}
              required
              options={[
                { label: "Staff A", value: "staff_a" },
                { label: "Staff B", value: "staff_b" },
              ]}
              placeholder="Select Staff"
            />
          </div>

          <div className={styles.row}>
            <label className={styles.checkLabel}>
              <input
                type="checkbox"
                checked={aboveCapStudent}
                onChange={(e) => setAboveCapStudent(e.target.checked)}
              />{" "}
              Send submission on email to above staffs
            </label>
            <label className={styles.checkLabel}>
              <input
                type="checkbox"
                checked={aboveCapStaff}
                onChange={(e) => setAboveCapStaff(e.target.checked)}
              />{" "}
              Allow parents to initiate application
            </label>
          </div>

          <div className={styles.row}>
            <div className={styles.inputBlock}>
              <label className={styles.inputLabel}>
                HTML to embed in the header
              </label>
              <textarea className={styles.textarea} />
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.inputBlock}>
              <label className={styles.inputLabel}>
                HTML to embed in the footer
              </label>
              <textarea className={styles.textarea} />
            </div>
          </div>

          <div className={styles.footerActions}>
            <SaveAndCancel
              onSave={handleProgramSave}
              onCancel={handleProgramCancel}
            />
          </div>
        </div>
      </div>

      {/* Assign Students */}
      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Assign Students" />
        </div>
        <div className={styles.studentdata}>
          <div className={styles.controls}>
            <SearchBar
              placeholder="Search Student"
              onChange={(e) => setSearch(e.target.value)}
            />
            <Dropdown
              bgColor="var(--Utility_Color9)"
              label="Room"
              options={["Room A", "Room B"]}
            />
          </div>

          <div className={styles.listHeader}>
            <label className={styles.checkLabel}>
              <input
                type="checkbox"
                checked={selectedStudents.length === filteredStudents.length}
                onChange={(e) =>
                  setSelectedStudents(
                    e.target.checked ? filteredStudents.map((s) => s.id) : []
                  )
                }
              />
              <span>Select All</span>
            </label>

            <span>{selectedStudents.length} Selected</span>
          </div>

          <div className={styles.grid}>
            {filteredStudents.map((student) => (
              <label key={student.id} className={styles.studentBox}>
                <div className={styles.checkboxRow}>
                  <input
                    type="checkbox"
                    checked={selectedStudents.includes(student.id)}
                    onChange={() => handleCheckboxChange(student.id)}
                  />
                  <span>{student.name}</span>
                </div>
              </label>
            ))}
          </div>

          <div className={styles.footerActions}>
            <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
          </div>
        </div>
      </div>
      <div className={styles.nextButtonContainer}>
        <button className={styles.nextButton} onClick={handleNextClick}>
          Next
        </button>
      </div>
    </div>
  );
};

export default FormDetails;
